import { render, staticRenderFns } from "./DormitoryUserListSimple.vue?vue&type=template&id=17aab142&scoped=true&"
import script from "./DormitoryUserListSimple.vue?vue&type=script&lang=js&"
export * from "./DormitoryUserListSimple.vue?vue&type=script&lang=js&"
import style0 from "./DormitoryUserListSimple.vue?vue&type=style&index=0&id=17aab142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17aab142",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VForm,VRow})
